window.animateCounter = function (el, target, suffix = '') {
  // Keep the original string for letters/suffixes
  const original = target.toString();

  // Extract numeric part for counting
  const numericPart = parseFloat(original); 
  if (isNaN(numericPart)) {
    // If no number, just display the string directly
    el.textContent = original + suffix;
    return;
  }

  const hasDecimal = original.includes(".");
  const decimals = hasDecimal ? original.split(".")[1].length : 0;

  const duration = 1000;
  const startTime = performance.now();

  function formatWithSpaces(num) {
    // Format number with thousand separators
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function step(now) {
    const progress = Math.min((now - startTime) / duration, 1);
    const value = progress * numericPart;

    let display;
    if (hasDecimal) {
      display = value.toFixed(decimals);
    } else {
      display = Math.floor(value).toString();
    }

    // Display counting number + everything after the numeric part as-is
    const nonNumeric = original.replace(numericPart.toString(), ''); // keeps spaces, letters
    el.textContent = formatWithSpaces(display) + nonNumeric + suffix;

    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
};